<template>
    <div v-if="!item.hidden" class="menu-wrapper">
        <template v-if="!item.children || showedChild.length === 0">
            <app-link :to="resolvePath(item.path)">
                <el-menu-item :index="resolveFirstLevelPath(item.path)" :class="{ 'submenu-title-noDropdown': !isNest }">
                    <item v-if="item.meta" :icon="item.meta.icon" :title="item.meta.title" />
                </el-menu-item>
            </app-link>
        </template>
        <el-submenu v-else :index="resolvePath(item.path)">
            <template slot="title">
                <item v-if="item.meta" :icon="item.meta.icon" :title="item.meta.title" />
            </template>
            <template v-for="child in showedChild">
                <sidebar-item
                    v-if="child.children && child.children.length > 0 && child.children.filter(children => !children.hidden).length > 0"
                    :is-nest="true"
                    :item="child"
                    :key="child.path"
                    :base-path="resolvePath(child.path)"
                    class="nest-menu"
                ></sidebar-item>
                <app-link v-else :to="resolvePath(child.path)" :key="child.name">
                    <el-menu-item :index="resolvePath(child.path)">
                        <item v-if="child.meta" :icon="child.meta.icon" :title="child.meta.title" />
                    </el-menu-item>
                </app-link>
            </template>
        </el-submenu>
    </div>
</template>

<script>
/* eslint-disable */
import path from 'path'
import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'

export default {
    name: 'SidebarItem',
    components: {
        Item,
        AppLink
    },
    props: {
        // route object
        item: {
            type: Object,
            required: true
        },
        isNest: {
            type: Boolean,
            default: false
        },
        basePath: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            onlyOneChild: null
        }
    },
    computed: {
        showedChild() {
            return this.item.children.filter(children => !children.hidden)
        }
    },
    methods: {
        hasOneShowingChild(children, parent) {
            const showingChildren = children.filter(item => {
                if (item.hidden) {
                    return false
                } else {
                    // Temp set(will be used if only has one showing child)
                    this.onlyOneChild = item
                    return true
                }
            })

            // When there is only one child router, the child router is displayed by default
            if (showingChildren.length === 1) {
                return true
            }

            // Show parent if there are no child router to display
            if (showingChildren.length === 0) {
                this.onlyOneChild = {
                    ...parent,
                    path: '',
                    noShowingChildren: true
                }
                return true
            }

            return false
        },
        resolvePath(routePath) {
            if (this.isExternalLink(routePath)) {
                return routePath
            }
            return path.resolve(this.basePath, routePath)
        },
        isExternalLink(routePath) {
            return isExternal(routePath)
        },
        resolveFirstLevelPath(routePath) {
            // 第一级无子菜单导航栏active状态处理
            if (!this.isNest) {
                return this.basePath
            }
            this.resolvePath(routePath)
        }
    }
}
</script>
